import { Injectable, Optional, Inject } from '@angular/core';
import { GenericTranslationService } from '../../services/generic-translation.service';
import { 
  ComponentConfig, 
  createComponentConfigToken, 
  createConfigProvider 
} from '../../services/translation-config.helper';
import { GenericUploadTranslations, GenericUploadTranslationInput } from './generic-upload-translations.interface';
import { DEFAULT_GENERIC_UPLOAD_TRANSLATIONS } from './generic-upload-translations.defaults';
import { GERMAN_GENERIC_UPLOAD_TRANSLATIONS } from './generic-upload-translations.de';

/**
 * Configuration for Generic Upload translations
 */
export interface GenericUploadConfig extends ComponentConfig<GenericUploadTranslations> {}

/**
 * Injection token for Generic Upload configuration
 */
export const GENERIC_UPLOAD_CONFIG = createComponentConfigToken<GenericUploadTranslations>('GENERIC_UPLOAD_CONFIG');

/**
 * Service for managing Generic Upload translations
 * Extends GenericTranslationService with language registry
 */
@Injectable({
  providedIn: 'root'
})
export class GenericUploadTranslationService extends GenericTranslationService<GenericUploadTranslations> {
  
  constructor(
    @Optional() @Inject(GENERIC_UPLOAD_CONFIG) config?: GenericUploadConfig
  ) {
    super(DEFAULT_GENERIC_UPLOAD_TRANSLATIONS);
    
    // Register available languages
    this.registerLanguage('de', GERMAN_GENERIC_UPLOAD_TRANSLATIONS);
    
    // Initialize with config translations if provided
    if (config?.translations) {
      this.setGlobalTranslations(config.translations);
    }
  }
}

/**
 * Provider for global Generic Upload configuration
 * Usage in app.module.ts:
 * 
 * providers: [
 *   GenericUploadConfigProvider.forRoot({
 *     translations: myTranslations
 *   })
 * ]
 */
export const GenericUploadConfigProvider = createConfigProvider<GenericUploadTranslations>(GENERIC_UPLOAD_CONFIG);
